import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function IndustriesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <section className="relative overflow-hidden bg-white grid-bg pt-36 pb-20">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(13,148,136,0.14), transparent 58%), radial-gradient(ellipse at 85% 20%, rgba(249,115,22,0.10), transparent 55%)' }}
        ></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center flex flex-col items-center">
            <div className="eyebrow">Who We Help</div>
            <h1 className="mt-6 h-display text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
              Industries We Serve
            </h1>
            <p className="mt-6 text-lg md:text-xl text-slate-600 font-body font-light max-w-2xl">
              Specialized AI marketing solutions for Florida's top business sectors.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <Link to="/industries/home-services" className="group bg-white rounded-2xl p-8 border-2 border-navy-100 hover:border-teal-500 hover:shadow-xl transition-all cursor-pointer">
              <div className="w-20 h-20 mb-6 rounded-xl overflow-hidden">
                <img
                  src="https://ugmsgrbawrdcehdgdjin.supabase.co/storage/v1/object/public/brand-assets/stock-images/home-services-001.jpg"
                  alt="Home Services"
                  className="w-full h-full object-cover"
                />
              </div>
              <h2 className="text-2xl font-bold font-display text-navy-900 mb-4 group-hover:text-teal-600 transition-colors">
                Home Services
              </h2>
              <p className="text-navy-600 mb-4 leading-relaxed text-sm">
                Roofing, HVAC, plumbing, remodeling, and contractors
              </p>
              <div className="flex items-center text-teal-600 font-semibold text-sm group-hover:translate-x-2 transition-transform">
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </Link>

            <Link to="/industries/professional-services" className="group bg-white rounded-2xl p-8 border-2 border-navy-100 hover:border-teal-500 hover:shadow-xl transition-all cursor-pointer">
              <div className="w-20 h-20 mb-6 rounded-xl overflow-hidden">
                <img
                  src="https://ugmsgrbawrdcehdgdjin.supabase.co/storage/v1/object/public/brand-assets/stock-images/pro-services-001.jpg"
                  alt="Professional Services"
                  className="w-full h-full object-cover"
                />
              </div>
              <h2 className="text-2xl font-bold font-display text-navy-900 mb-4 group-hover:text-teal-600 transition-colors">
                Professional Services
              </h2>
              <p className="text-navy-600 mb-4 leading-relaxed text-sm">
                Law firms, accounting, consulting, and business services
              </p>
              <div className="flex items-center text-teal-600 font-semibold text-sm group-hover:translate-x-2 transition-transform">
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </Link>

            <Link to="/industries/real-estate" className="group bg-white rounded-2xl p-8 border-2 border-navy-100 hover:border-teal-500 hover:shadow-xl transition-all cursor-pointer">
              <div className="w-20 h-20 mb-6 rounded-xl overflow-hidden">
                <img
                  src="https://ugmsgrbawrdcehdgdjin.supabase.co/storage/v1/object/public/brand-assets/stock-images/real-estate-001.jpg"
                  alt="Real Estate"
                  className="w-full h-full object-cover"
                />
              </div>
              <h2 className="text-2xl font-bold font-display text-navy-900 mb-4 group-hover:text-teal-600 transition-colors">
                Real Estate
              </h2>
              <p className="text-navy-600 mb-4 leading-relaxed text-sm">
                Agents, brokers, property management, and developers
              </p>
              <div className="flex items-center text-teal-600 font-semibold text-sm group-hover:translate-x-2 transition-transform">
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </div>
            </Link>
          </div>

          <div className="mt-16 bg-navy-50 rounded-2xl p-12 border-2 border-navy-100 text-center">
            <h2 className="text-3xl font-bold font-display text-navy-900 mb-4">
              Don't See Your Industry?
            </h2>
            <p className="text-base text-navy-600 mb-8 max-w-2xl mx-auto leading-relaxed">
              We also work with healthcare practices, local brands, franchises, and other Florida businesses. Our AI marketing solutions adapt to any industry.
            </p>
            <Link
              to="/contact"
              className="btn-primary inline-flex items-center px-8 py-4 whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
